function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 26.458333 26.458334",
    id: "svg17343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-270.54165)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19401787,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-8-83",
    width: 18.708866,
    height: 18.708866,
    x: 200.65627,
    y: 181.94742,
    transform: "rotate(44.999998)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16491526,
      strokeOpacity: 1
    },
    d: "m 13.22917,272.52606 -11.2447921,11.2448 4.630209,4.6302 v -5.95312 -1.85208 h 3.175 v -2.11667 h 1.3229171 v 2.11667 h 8.73125 v 1.85208 5.95312 l 4.630208,-4.6302 z m -5.0270831,9.6573 v 7.14375 h 1.5875 v -5.29167 h 2.3812501 v 5.29167 h 6.085417 v -7.14375 z m 0.926041,8.73125 4.1010421,4.10104 4.101042,-4.10104 z",
    id: "rect4518-8-4-5-38-6"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.06666873,
      strokeOpacity: 1
    },
    id: "rect8773-0-7-7-7-4-2",
    width: 2.6458333,
    height: 1.0583333,
    x: 284.03546,
    y: -14.552087,
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.06666873,
      strokeOpacity: 1
    },
    id: "rect8773-0-7-7-7-4-2-0",
    width: 2.6458333,
    height: 1.0583333,
    x: 284.03546,
    y: -16.801044,
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 15.74788,289.72811 -4.328935,4.32944 0.561209,0.56121 4.328934,-4.32944 z",
    id: "rect8773-0-4-6-2-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 12.628692,289.85368 -2.7068131,2.70681 0.5612061,0.5612 2.706812,-2.7068 z",
    id: "rect8773-0-4-6-2-8-1-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHut);
export default __webpack_public_path__ + "static/media/icon-hut.95e4db0071d7c76dc82355560ed0cea0.svg";
export { ForwardRef as ReactComponent };